import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
      {items.map((item, idx) => (
        <span key={item.label} className="flex items-center gap-2">
          {idx > 0 && <i className="ri-arrow-right-s-line text-secondary-400"></i>}
          {item.path ? (
            <Link to={item.path} className="transition-colors hover:text-primary-600 cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}